import { useCallback, useEffect, useRef, useState } from "react";
import { getReplenishmentEmails, postReplenishmentEmails,putReplenishmentEmails } from "../../services/AllServices";
import { showMessage } from "../../utils/helpers";
import { useFormik } from "formik";

const useReplenishmentMailViewController = () => {

    const [ownStoreEmailEditState, setOwnStoreEmailEditState] = useState(false)
    const [watsonStoreEmailEditState, setWatsonStoreEmailEditState] = useState(false)
    const [ecomPlatformEmailEditState, setEcomPlatformEmailEditState] = useState(false)
    const [warehouseEmailEditState, setWarehouseEmailEditState] = useState(false)
    const [emailData, setEmailData] = useState({});
    const renderAfterCalled = useRef(false);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getReplenishmentEmails();
            setEmailData(response);
            if(response?.own_store_email){
                setOwnStoreEmailEditState(true)
            }
            if(response?.ecom_platform_email){
                setEcomPlatformEmailEditState(true)
            }
            if(response?.watson_store_email){
                setWatsonStoreEmailEditState(true)
            }
            if(response?.warehouse_email){
                setWarehouseEmailEditState(true)
            }
        } catch (error) {
            showMessage("error", error?.data.message || "Something went wrong");
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        if (!renderAfterCalled.current) {
            fetchData();
        }
        renderAfterCalled.current = true;
    }, [fetchData]);

    const { setFieldValue, values, handleSubmit, handleChange,touched,errors } = useFormik({
        initialValues: {
            ownStoreEmail: emailData?.own_store_email || "",
            watsonStoreEmail: emailData?.watson_store_email || "",
            ecomPlatformEmail: emailData?.ecom_platform_email || "",
            warehouseEmail: emailData?.warehouse_email || "",
        
        },
        enableReinitialize: true,
        onSubmit: async () => {
            setLoading(true);
            try {
                const sendBody = {
                    own_store_email:values?.ownStoreEmail,
                    watson_store_email :values?.watsonStoreEmail,
                    ecom_platform_email: values?.ecomPlatformEmail,
                    warehouse_email:values?.warehouseEmail
                }
                    await putReplenishmentEmails(sendBody);
                    showMessage("success", "User Updated Successfully");
              
                fetchData();
            } catch (error) {
                showMessage("error", error?.data.message || "Something went wrong");
            }
            setLoading(false);
        },
    });




    return {
        handleSubmit,
        values,
        emailData,
        loading,
        submitLoading,
        handleChange,
        ownStoreEmailEditState,
        setOwnStoreEmailEditState,
        warehouseEmailEditState,
        setWarehouseEmailEditState,
        ecomPlatformEmailEditState,
        setEcomPlatformEmailEditState,
        watsonStoreEmailEditState,
        setWatsonStoreEmailEditState,
        touched,
        errors,
        fetchData,
    };
};

export default useReplenishmentMailViewController;


